
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"55mm","height":"336","viewBox":"0 0 55 88.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"colorable",attrs:{"d":"M27.5 29.712c-5.02 0-9.088 4.399-9.088 9.825v9.826c0 5.426 4.069 9.825 9.088 9.825 5.02 0 9.088-4.399 9.088-9.825v-9.826c0-5.426-4.069-9.825-9.088-9.825zm0 4.913c2.51 0 4.544 2.2 4.544 4.912v9.826c0 2.713-2.034 4.912-4.544 4.912s-4.544-2.2-4.544-4.912v-9.826c0-2.713 2.034-4.912 4.544-4.912z","fill-rule":"evenodd"}}),_c('g',{staticClass:"fg_background",attrs:{"fill":"#fff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11.596 7.605c-2.51 0-4.544 2.2-4.544 4.913v4.912c0 2.714 2.035 4.913 4.544 4.913 2.51 0 4.544-2.2 4.544-4.913v-4.912c0-2.713-2.034-4.913-4.544-4.913zm0 2.456c1.255 0 2.272 1.1 2.272 2.457v4.912c0 1.357-1.017 2.457-2.272 2.457s-2.272-1.1-2.272-2.457v-4.912c0-1.357 1.017-2.457 2.272-2.457zM43.404 66.557c-2.51 0-4.544 2.2-4.544 4.913v4.912c0 2.713 2.034 4.913 4.544 4.913s4.544-2.2 4.544-4.913V71.47c0-2.714-2.035-4.913-4.544-4.913zm0 2.456c1.255 0 2.272 1.1 2.272 2.457v4.912c0 1.357-1.017 2.456-2.272 2.456s-2.272-1.1-2.272-2.456V71.47c0-1.357 1.017-2.457 2.272-2.457z"}})])])
          )
        }
      }
    